import React, { FC, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import styled from 'styled-components';
import { Input } from 'components/atoms/input';
import { DefaultCurrencyCode } from 'components/organisms/templates/forms/form-builder/constants';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledInput = styled(Input)`
  margin-top: var(--spacing-03);
  padding: var(--spacing-03) var(--spacing-05) !important;
  .ant-input-prefix {
    border-right: 1px solid var(--gray-40);
    padding-right: var(--spacing-04);
  }
  .ant-input {
    padding-left: var(--spacing-03);
  }
`;

export const CurrencyField: FC<FormFieldProps> = ({
  field,
  setValue,
  errors,
  control,
  disabled,
}) => {
  const defaultCurrencyPrefix = useMemo(() => {
    return field.questionMeta?.currencySymbol ?? DefaultCurrencyCode;
  }, [field.questionMeta]);

  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <StyledInput
            prefix={defaultCurrencyPrefix}
            type="number"
            disabled={disabled}
            bordered={false}
            ref={props.field.ref}
            value={props.field.value}
            onChange={(e) =>
              setValue?.(
                field.questionId.toString(),
                e.target.value
                  ? Math.abs(Number(e.target.value)).toString()
                  : undefined,
              )
            }
          />
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
      <FormItemDesc label={field.description} />
    </FormItemWrapper>
  );
};
